export default "__VITE_ASSET__52bcf45b__"